import { render, staticRenderFns } from "./scopeManage.vue?vue&type=template&id=296a93e1&scoped=true"
import script from "./scopeManage.vue?vue&type=script&lang=js"
export * from "./scopeManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296a93e1",
  null
  
)

export default component.exports